module.exports = __webpack_public_path__ + "img/503.0d9b94a7.jpg";